export default __webpack_public_path__ + "c0fea76763ca6dc7c218df084e18b745.svg";